var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTool1X3 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none",
  viewBox: "0 0 15 15",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 14,
  x: 0.5,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 1.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 14,
  x: 0.5,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 14,
  x: 5.857,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 1.5
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 14,
  x: 5.857,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  width: 3.286,
  height: 14,
  x: 11.214,
  y: 0.5,
  stroke: "#6AD2FF",
  rx: 0.5
})));
export { SvgTool1X3 as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-1x3.svg";